import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import MainRoutes from './routes/Routes';
import Loading from '@components/Loading/Loading';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorBoundaryComponent } from './components/ErrorBoundary';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-phone-input-2/lib/style.css';
import { useDispatch, useSelector } from 'react-redux';
import { API_URL } from './utils/apiUrl';
import axiosWrapper from './utils/api';
import { updateUserProfile } from './redux/auth/auth_slice';
import { useLocation, useNavigate } from 'react-router-dom';

function App() {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { userToken, userInfo } = useSelector((state) => state.auth);
    const headerColor = '#00AB36';

    useEffect(() => {
        // Find or create the theme-color meta tag
        let metaThemeColor = document.querySelector('meta[name=theme-color]');
        if (!metaThemeColor) {
            metaThemeColor = document.createElement('meta');
            metaThemeColor.setAttribute('name', 'theme-color');
            document.head.appendChild(metaThemeColor);
        }
        metaThemeColor.setAttribute('content', headerColor);
    }, [headerColor]);

    const handleGetCurrentUser = async (userToken) => {
        // Call API to get current user
        const response = await axiosWrapper('GET', API_URL.GET_CURRENT_USER, {}, userToken);
        dispatch(updateUserProfile(response?.data));
    };

    const handleGetCurrentParker = async (userToken) => {
        // Call API to get current user
        const response = await axiosWrapper('GET', API_URL.GET_CURRENT_PARKER, {}, userToken);
        dispatch(updateUserProfile(response?.data));
    };

    useEffect(() => {
        const paths = ['/parker', '/admin', '/group-admin'];
        const matches = paths.some((path) => location?.pathname?.startsWith(path));
        if (userToken && matches) {
            if (userInfo?.role === 'PARKER') {
                handleGetCurrentParker(userToken);
            } else {
                handleGetCurrentUser(userToken);
            }
        }
    }, [userToken]);
    useEffect(() => {
        const paths = ['/parker', '/admin', '/group-admin'];
        const matches = paths.some((path) => location?.pathname?.startsWith(path));
        if (performance.getEntriesByType('navigation')[0]?.type === 'reload' && !matches) {
            navigate('/');
        }
    }, []);

    return (
        <ErrorBoundary fallbackRender={({ error }) => <ErrorBoundaryComponent error={error} />}>
            <React.Suspense fallback={<Loading centered size={'lg'} />}>
                <React.Fragment>
                    <MainRoutes />
                    <ToastContainer autoClose={3000} />
                </React.Fragment>
            </React.Suspense>
        </ErrorBoundary>
    );
}

export default App;
